/* eslint-disable no-undef */
import React from 'react';
import { Link } from 'react-router-dom';
import EventTopBar from '../event-template/EventTopBar';
import EventFooter from '../event-template/EventFooter';
import _ from 'lodash';
import { usersService } from '../../../_services/usersService';
import ResponseFilter from '../../../config/response-handler';
import moment from 'moment';
import Cookies from 'js-cookie';
import { Input, Popover } from 'antd';
import { Loader, PlusIcon, MinusIcon, Delete } from '../../../config/Svgicon';

class EventCart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quantTotal: '',
      ticketPassword: '',
      visible: false,
      totalLength: 0,
      listquantTotal: '',
      loader: false,
      popupVisible: false,
      eventId: '',
      subtotal: 0,
      ticketsList: [],
      maxQuantity: '10',
      eventName: props.location.state ? props.location.state.eventName : '',
      eventImage: props.location.state ? props.location.state.eventImage : '',
      eventPlatform: props.location.state
        ? props.location.state.eventPlatform
        : '',
      loaction: props.location.state ? props.location.state.loaction : '',
      address2: props.location.state ? props.location.state.address2 : '',
      city: props.location.state ? props.location.state.city : '',
      state: props.location.state ? props.location.state.state : '',
      zip: props.location.state ? props.location.state.zip : '',
      isAddressHide: props.location.state ? props.location.state.isAddressHide : 2,
      timeZone: props.location.state ? props.location.state.timeZone : '',
      eventDate: props.location.state ? props.location.state.eventDate : '',
      eventDays: props.location.state ? props.location.state.eventDays : '',
      endTimeStamp: props.location.state
        ? props.location.state.endTimeStamp
        : '',
      startTimeStamp: props.location.state
        ? props.location.state.startTimeStamp
        : '',
      hour: props.location.state ? props.location.state.hour : '',
      minute: props.location.state ? props.location.state.minute : '',
      meridian: props.location.state ? props.location.state.meridian : '',
      hourEnd: props.location.state ? props.location.state.hourEnd : '',
      minuteEnd: props.location.state ? props.location.state.minuteEnd : '',
      meridianEnd: props.location.state ? props.location.state.meridianEnd : '',
      eventPayout: props.location.state ? props.location.state.eventPayout : '',
      successPageMessage: props.location.state
        ? props.location.state.successPageMessage
        : '',
      separateTicketDeliveryMode: props.location.state ? props.location.state.separateTicketDeliveryMode : 'off',
    };

    this.handleClickPopupVisible = this.handleClickPopupVisible.bind(this);
  }
  handleVisibleChange = (visible, id) => {
    this.setState({ visible, ticketIdMatch: id });
  };

  hidePopup = () => {
    this.setState({ ticketIdMatch: '', errorMsgShow: '', ticketPassword: '' });
  };
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      [e.target.name + 'ErrorMsg']: '',
    });
  };
  getEventPage = () => {
    console.log(this.props);
    if(this.props.match.params&&this.props.match.params.id){

      let obj = {
        eventId: this.props.match.params.id,
      };
   
      usersService.eventDetails(obj).then((res) => {
        let { status, resData } = ResponseFilter(res);
        console.log(status,resData);
        if (status) {
          console.log('route to event');
          this.props.history.push({
            pathname: '/event/'+this.props.match.params.id+'/'+encodeURIComponent(resData.result.eventName),
          });
        }
      });
      console.log('route to home');
    } else {
        this.props.history.push({
          pathname: '/',
        });
    }
  }
  componentDidMount() {
    document.title = 'Cart | Farechild';
    this.ticketList();
    console.log('cookies',{ ...localStorage });
    console.log('props',this.props);
    console.log('eventId',this.state.eventId);
    console.log('state',this.state);
    console.log('referrer',document.referrer);
    let ID = localStorage.getItem('eventID') ? localStorage.getItem('eventID') : '';
    if(!this.props.location.state){
      this.getEventPage();
    }
    /*if(!localStorage.getItem('ccFeesValue')||!localStorage.getItem('checkoutFields')||!localStorage.getItem('perTicketFeesValue')||!localStorage.getItem('transactionFeesValue')||!localStorage.getItem('cf_clearance')){
      if(!this.state.eventId){
        this.props.history.push({
          pathname: '/event/'+this.props.match.params.id,
        });
      }
    }*/
    if (ID !== this.props.match.params.id) {
      localStorage.removeItem('PerTicketFee');
      localStorage.removeItem('CCFees');
      localStorage.removeItem('TransactionFee');
      localStorage.removeItem('quantTotal');
      localStorage.removeItem('selectObjList');
      localStorage.removeItem('subtotal');
      localStorage.removeItem('orderTicketList');
      localStorage.removeItem('separateTicketDeliveryMode')
      localStorage.setItem('eventID', this.props.match.params.id);
    }

  }
  
  handleClickPopupVisible() {
    this.setState((prevState) => ({
      popupVisible: !prevState.popupVisible,
    }));
  }

  ticketList = () => {
    let obj = {
      eventId: this.props.match.params.id,
    };

    this.setState({ loader: true });
    usersService.ticketList(obj).then((res) => { // grab list of tickets for this event (?)
      let { status, resData } = ResponseFilter(res);
      if (status) {
        var arrOfObj = resData.result;
        var newresult = arrOfObj.map(function (el) {
          var o = Object.assign({}, el);
          console.log('o: ', o)
          o.ticketId = el._id;
          o.ticketPasswordCheck =
            el.ticketPassword &&
            el.ticketPassword !== '' &&
            el.ticketPassword !== null &&
            el.ticketPassword !== undefined
              ? false
              : true;
          o.ticketQuantity = 0;
          o.ticketPrice = el.price === null ? 0 : el.price;
          o.ticketPriceShow = el.price === null ? 0 : el.price;
          return o;
        });

        const result = newresult.filter((e) => e.quantity !== 0);

        const quantTotal = result.reduce((total, product) => {
          return total + product.ticketQuantity;
        }, 0);
        const listquantTotal = arrOfObj.reduce((total, product) => {
          return total + product.quantity;
        }, 0);

        this.setState({
          quantTotal: quantTotal,
          listquantTotal: listquantTotal,
        });
        this.setState({
          loader: false,
          ticketsList: result,
          totalCount: resData.count,
        });
      }
    });
  };

  handlePasswordCheck = (Id, i) => {
    let ticketsList = localStorage.getItem('selectObjList')
      ? JSON.parse(localStorage.getItem('selectObjList'))
      : this.state.ticketsList;

    let params = {
      ticketId: Id,
      ticketPassword: this.state.ticketPassword,
    };

    usersService.verifyTicketPassword(params).then((res) => {
      if (res.data.statusCode === 1) {
        ticketsList[i].ticketPasswordCheck = true;
        this.setState({ ticketsList }, () => this.hidePopup());
        localStorage.setItem('selectObjList', JSON.stringify(ticketsList));
        message.success('Ticket verified successfully!');
      } else {
        this.setState({
          errorMsgShow: 'Invalid password, please try again.',
        });
      }
    });
  };

  ticketAddToCart = (item, action, i) => {
    let ticketsList = localStorage.getItem('selectObjList')
      ? JSON.parse(localStorage.getItem('selectObjList'))
      : this.state.ticketsList;

    if (action === 1) { // remove a ticket
      if (Number(item.ticketQuantity) > 1) {
        ticketsList[i].ticketQuantity = ticketsList[i].ticketQuantity - 1;
        ticketsList[i].ticketPriceShow =
          ticketsList[i].price * ticketsList[i].ticketQuantity;
        this.setState({ ticketsList }, () => this.Summary());
        localStorage.setItem('selectObjList', JSON.stringify(ticketsList));
      }
    } else if (action === 2) { // add a ticket
      if (item.ticketPasswordCheck) {
        this.setState({ ticketIdMatch: '' });
        if (
          Number(item.maxQuantity ? item.maxQuantity : 10) >
          Number(item.ticketQuantity)
        ) {
          if (Number(item.quantity) > Number(item.ticketQuantity)) {
            ticketsList[i].ticketQuantity = ticketsList[i].ticketQuantity + 1;
            ticketsList[i].ticketPriceShow =
              ticketsList[i].price * ticketsList[i].ticketQuantity;
            this.setState({ ticketsList }, () => this.Summary());
            localStorage.setItem('selectObjList', JSON.stringify(ticketsList));
          }
        }
      } else {
        this.setState({
          ticketIdMatch:
            item.ticketPassword &&
            item.ticketPassword !== '' &&
            item.ticketPassword !== undefined &&
            item.ticketPassword !== null
              ? item._id
              : '',
        });
      }
    } else if (action === 3) { // delete all tickets of this type
      ticketsList[i].ticketQuantity = 0;
      ticketsList[i].ticketPriceShow =
        ticketsList[i].price * ticketsList[i].ticketQuantity;
      this.setState({ ticketsList }, () => this.Summary());
      localStorage.setItem('selectObjList', JSON.stringify(ticketsList));
    }
  };

  Summary() {
    let ticketsList = localStorage.getItem('selectObjList')
      ? JSON.parse(localStorage.getItem('selectObjList'))
      : this.state.ticketsList;

    const orderTicketList = ticketsList.filter(
      (e) => e.ticketQuantity !== 0 && e !== undefined
    );
    localStorage.setItem('orderTicketList', JSON.stringify(orderTicketList));

    const arr = orderTicketList.filter(
      (e) => e.ticketPriceShow !== 0 && e !== undefined
    );

    const PerTicketFeeTotal = arr.reduce((total, product) => {
      return total + product.ticketQuantity;
    }, 0);

    const PerTicketFee = (
      PerTicketFeeTotal * localStorage.getItem('perTicketFeesValue')
    ).toFixed(2);
    localStorage.setItem('PerTicketFee', PerTicketFee);

    this.setState({ totalLength: orderTicketList.length });
    const quantTotal = orderTicketList.reduce((total, product) => {
      return total + product.ticketQuantity;
    }, 0);
    this.setState({ quantTotal: quantTotal });
    localStorage.setItem('quantTotal', quantTotal);

    const subtotal = orderTicketList.reduce((total, product) => {
      return total + product.ticketPriceShow;
    }, 0);
    this.setState({ subtotal: subtotal });
    localStorage.setItem('subtotal', subtotal);

    const CCFees = subtotal * (localStorage.getItem('ccFeesValue') / 100);
    localStorage.setItem('CCFees', CCFees.toFixed(2));
    const TransactionFee =
      subtotal * (localStorage.getItem('transactionFeesValue') / 100);
    localStorage.setItem('TransactionFee', TransactionFee.toFixed(2));
  }

  render() {
    let {
      loader,
      listquantTotal,
      totalLength,
      eventDate,
      timeZone,
      eventDays,
      endTimeStamp,
      startTimeStamp,
    } = this.state;
    var parse = require('html-react-parser');
    var days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];

    let totalFees = (
      Number(localStorage.getItem('PerTicketFee') ? localStorage.getItem('PerTicketFee') : 0) +
      Number(localStorage.getItem('CCFees') ? localStorage.getItem('CCFees') : 0) +
      Number(localStorage.getItem('TransactionFee') ? localStorage.getItem('TransactionFee') : 0)
    ).toFixed(2);
    let quantTotal = localStorage.getItem('quantTotal')
      ? localStorage.getItem('quantTotal')
      : this.state.quantTotal;
    let SummaryArray = localStorage.getItem('selectObjList')
      ? JSON.parse(localStorage.getItem('selectObjList'))
      : this.state.ticketsList;
    let SummaryArrayLenght = localStorage.getItem('orderTicketList')
      ? JSON.parse(localStorage.getItem('orderTicketList'))
      : '';
    let Summarytotal = localStorage.getItem('subtotal')
      ? localStorage.getItem('subtotal')
      : this.state.subtotal;

    return (
      <div className="base-wrapper event-detail">
        {loader ? <Loader /> : null}
        <EventTopBar {...this.props} hideCart={true} />
        <div className="">
          <div className="sidebar-overlay"></div>
          <div className="content content-event content-event-cart">
            <h3 className="content-title">cart</h3>
            <div className="card mb-5">
              <div className="card-body p-0">
                <div className="row no-gutters">
                  <div className="col-lg-8 border-right">
                    <div className="d-flex  flex-column h-100">
                      <div
                        className="p-4 border-bottom w-100"
                        onMouseEnter={this.hidePopup}
                      >
                        <h3 className="text-capitalize name-ticket">
                          {this.state.eventName}
                        </h3>
                        <p
                          className="m-0 font-size-14"
                          onMouseEnter={this.hidePopup}
                        >
                          {this.state.eventPlatform === 1 ? (
                            <>
                              {eventDays && eventDays.length !== 0
                                ? eventDays[0]
                                : days[
                                    new Date(
                                      moment(eventDate[0]).format('DD MMM YYYY')
                                    ).getDay()
                                  ]}
                              - {moment(eventDate[0]).format('MMM DD, yyyy')},{' '}
                              {this.state.hour}:{this.state.minute}{' '}
                              {this.state.meridian}
                              <React.Fragment>
                                {' '}
                                -{' '}
                                {eventDays && eventDays.length !== 0
                                  ? eventDays[1]
                                  : days[
                                      new Date(
                                        moment(eventDate[1]).format(
                                          'DD MMM YYYY'
                                        )
                                      ).getDay()
                                    ]}{' '}
                                - {moment(eventDate[1]).format('MMM DD, yyyy')},{' '}
                                {this.state.hourEnd}:{this.state.minuteEnd}{' '}
                                {this.state.meridianEnd}
                              </React.Fragment>
                            </>
                          ) : (
                            <>
                              {
                                days[
                                  new Date(
                                    moment(startTimeStamp).format('DD MMM YYYY')
                                  ).getDay()
                                ]
                              }{' '}
                              - {moment(startTimeStamp).format('MMM DD, yyyy')},{' '}
                              {new Date(startTimeStamp).toLocaleTimeString(
                                'en-us',
                                {
                                  hour: '2-digit',
                                  minute: '2-digit',
                                }
                              )}
                              <React.Fragment>
                                {' '}
                                -{' '}
                                {
                                  days[
                                    new Date(
                                      moment(endTimeStamp).format('DD MMM YYYY')
                                    ).getDay()
                                  ]
                                }{' '}
                                - {moment(endTimeStamp).format('MMM DD, yyyy')},{' '}
                                {new Date(endTimeStamp).toLocaleTimeString(
                                  'en-us',
                                  {
                                    hour: '2-digit',
                                    minute: '2-digit',
                                  }
                                )}
                              </React.Fragment>
                            </>
                          )}{' '}
                          {this.state.eventPlatform == 2 ? (
                                  <>{timeZone ? <>({timeZone})</> : ''}</>
                                ) : (
                                  ''
                                )}
                        {this.state.isAddressHide === 1 ? '' : 
                        (
                          this.state.eventPlatform === 2 ? (
                            <span className="m-0">| Virtual </span>
                          ) : (
                            <span className="m-0">
                              | {' '}
                              {this.state.loaction},{' '}
                              {this.state.address2
                                ? `${this.state.address2}, `
                                : ''}
                              {this.state.city}, {this.state.state},{' '}
                              {this.state.zip}
                            </span>
                          ))}
                        </p>
                      </div>

                      {!_.isEmpty(SummaryArray) ? (
                        <React.Fragment>
                          {SummaryArray.map((item, i) => {
                            return (
                              <React.Fragment>
                                {item.quantity <= 0||item.disabled ? (
                                  ''
                                ) : (
                                  <div className="w-100 mb-auto border-bottom">
                                    <div className="row m-4 no-gutters">
                                      <div
                                        onMouseEnter={this.hidePopup}
                                        className={`${
                                          item.ticketQuantity > 0
                                            ? 'col-lg-7 col-md-7'
                                            : 'col-lg-8 col-md-8'
                                        }`}
                                      >
                                        <div className="pb-4 pt-3 flex-grow-1">
                                          <h3 className="text-capitalize font-weight-bold name-ticket">
                                            {item.ticketName}
                                          </h3>
                                          <p className="m-0 font-size-14">
                                            {parse(item.description)}
                                          </p>
                                          <h4 className="mt-2 price">
                                            $
                                            {item.price
                                              ? Number(item.price).toFixed(2)
                                              : Number(0).toFixed(2)}
                                          </h4>
                                          {(item.startDate && item.endDate) &&      <p class="font-size-12">{`This ticket is on sale from ${moment(item.startDate).format("MM/DD/YYYY hh:mm a")} to ${moment(this.state.endTimeStamp).format("MM/DD/YYYY hh:mm a")}`}</p>}

                                          {/* {(item.startDate && item.endDate) &&      <p class="font-size-12">{`This ticket is on sale from ${moment(item.startDate).format("MM/DD/YYYY hh:mm a")} to ${moment(item.endDate).format("MM/DD/YYYY hh:mm a")}`}</p>} */}
                                        </div>
                                      </div>
                                      <div
                                        className={`${
                                          item.ticketQuantity > 0
                                            ? 'col-xl-4 col-lg-4 col-md-4'
                                            : 'col-xl-4 col-lg-4 col-md-4'
                                        }`}
                                      >
                                        <div className="pb-4 m-t-40  float-lg-right float-xl-right float-md-right float-sm-left">
                                          {/* {((!item.startDate && !item.endDate) || (moment(item.startDate) < moment() && moment(item.endDate) > moment())) ? ( <div class="CartItem-controls float-right mb-2 mt-2"> */}
                                          {((!item.startDate && !item.endDate) || (moment(item.startDate) < moment() && moment(this.state.endTimeStamp) > moment())) ? ( <div class="CartItem-controls float-right mb-2 mt-2">

                                            <span
                                              onMouseEnter={this.hidePopup}
                                              className="CartItem-count bg-white"
                                              onClick={() =>
                                                this.ticketAddToCart(item, 1, i)
                                              }
                                            >
                                              <MinusIcon />
                                            </span>
                                            <span className="CartItem-count">
                                              {item.ticketQuantity}
                                            </span>

                                            <Popover
                                              visible={
                                                this.state.ticketIdMatch ==
                                                item._id
                                              }
                                              trigger="click"
                                              content={
                                                <div
                                                  style={{
                                                    width: 350,
                                                    height: 87,
                                                  }}
                                                >
                                                  <div>
                                                    <Input.Password
                                                      type="text"
                                                      autoComplete="new-password"
                                                      maxLength="50"
                                                      size="large"
                                                      placeholder="Password"
                                                      name="ticketPassword"
                                                      value={
                                                        this.state
                                                          .ticketPassword
                                                      }
                                                      onChange={
                                                        this.handleChange
                                                      }
                                                    />
                                                  </div>

                                                  <div className="bg-white pull-right mt-3">
                                                    <button
                                                      className="btn btn-light mini-btn"
                                                      onClick={this.hidePopup}
                                                    >
                                                      Cancel
                                                    </button>
                                                    <button
                                                      disabled={
                                                        this.state
                                                          .ticketPassword ==
                                                          '' ||
                                                        this.state
                                                          .ticketPassword
                                                          .length < 6
                                                      }
                                                      className="btn btn-primary ml-2 mini-btn"
                                                      onClick={() =>
                                                        this.handlePasswordCheck(
                                                          item._id,
                                                          i
                                                        )
                                                      }
                                                    >
                                                      Submit
                                                    </button>
                                                  </div>
                                                </div>
                                              }
                                              title={
                                                <>
                                                  <p style={{ width: 350 }}>
                                                    This is a password protected
                                                    ticket. You need to enter
                                                    the password to purchase the
                                                    ticket.
                                                  </p>

                                                  {this.state.errorMsgShow ? (
                                                    <div className="error ml-0">
                                                      {this.state.errorMsgShow}
                                                    </div>
                                                  ) : null}
                                                </>
                                              }
                                            >
                                              <span
                                                className="CartItem-count bg-white"
                                                onClick={() =>
                                                  this.ticketAddToCart(
                                                    item,
                                                    2,
                                                    i
                                                  )
                                                }
                                              >
                                                <PlusIcon />
                                              </span>
                                            </Popover>
                                          </div> ) : ( <p className="text-danger">This ticket is not available at this time.</p>)}
                                        </div>
                                      </div>

                                      {item.ticketQuantity > 0 ? (
                                        <div className="col-xl-1 col-lg-1 col-md-1">
                                          <div className="mb-2 mt-5 float-lg-right float-xl-right float-md-right float-sm-left">
                                            <div
                                              title="remove"
                                              class="text-danger delete-cart-item"
                                              onClick={() =>
                                                this.ticketAddToCart(item, 3, i)
                                              }
                                            >
                                              <p>
                                                {' '}
                                                <Delete />
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        ''
                                      )}
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </React.Fragment>
                      ) : (
                        ''
                      )}

                      {listquantTotal < 1 && listquantTotal !== '' ? (
                        <div className="text-center">
                          <p className="mb-4 mb-sm-0 mt-4 font-weight-bold">
                            No Ticket Left{' '}
                          </p>
                        </div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                  <div
                    className="col-lg-4 d-none d-xl-block d-lg-block"
                    onMouseEnter={this.hidePopup}
                  >
                    <img
                      src={this.state.eventImage}
                      alt=""
                      title=""
                      className="w-100"
                    />

                    <div className="p-4" onMouseEnter={this.hidePopup}>
                      <h5 className="font-weight-bold pb-3">Order Summary</h5>

                      {SummaryArray.map((item, i) => {
                        return (
                          <React.Fragment>
                            {item.ticketQuantity !== 0 ? (
                              <React.Fragment>
                                {item.quantity <= 0 ? (
                                  ''
                                ) : (
                                  <div className="row no-gutters border-bottom">
                                    <div className="col-lg-8">
                                      <p className="text-capitalize">
                                        {item.ticketQuantity
                                          ? item.ticketQuantity
                                          : 0}{' '}
                                        x{' '}
                                        {item.ticketName ? item.ticketName : ''}
                                      </p>
                                    </div>
                                    <div className="col-lg-4">
                                      <p className="float-right">
                                        $
                                        {item.ticketPriceShow
                                          ? Number(
                                              item.ticketPriceShow
                                            ).toFixed(2)
                                          : Number(0).toFixed(2)}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </React.Fragment>
                            ) : (
                              ''
                            )}
                          </React.Fragment>
                        );
                      })}
                      <div className="row no-gutters border-bottom pt-4">
                        <div className="col-8">
                          <p>Subtotal</p>
                        </div>
                        <div className="col-4">
                          <p className="float-right">
                            $
                            {Summarytotal
                              ? Number(Summarytotal).toFixed(2)
                              : Number(0).toFixed(2)}
                          </p>
                        </div>
                        <div className="col-8">
                          <p>Fees</p>
                        </div>
                        <div className="col-4">
                          <p className="float-right">
                            ${Number(totalFees).toFixed(2)}
                          </p>
                        </div>
                      </div>
                      {
                        localStorage.getItem('eventID')=='66e9d2c940a762a1f54a667b'?(
                          <div className="row no-gutters pt-4">
                          <div className="col-8">
                            <p className="font-weight-bold">LET</p>
                          </div>
                          <div className="col-4">
                            <p className="float-right font-weight-bold">
                              ${((Number(Summarytotal) + Number(totalFees))*0.09).toFixed(
                                2
                              ) }
                            </p>
                          </div>
                        </div>
                        ):''
                      }
                      {
                        localStorage.getItem('eventID')=='66e9d2c940a762a1f54a667b'?(
                          <div className="row no-gutters pt-4">
                            <div className="col-8">
                              <p className="font-weight-bold">Total</p>
                            </div>
                            <div className="col-4">
                              <p className="float-right font-weight-bold">
                                $
                                {Number((Number(Summarytotal) + Number(totalFees)+Number((Number(Summarytotal) + Number(totalFees))*0.09))).toFixed(2)}
                              </p>
                            </div>
                          </div>
                        ):(
                          <div className="row no-gutters pt-4">
                            <div className="col-8">
                              <p className="font-weight-bold">Total</p>
                            </div>
                            <div className="col-4">
                              <p className="float-right font-weight-bold">
                                $
                                {Number((Number(Summarytotal) + Number(totalFees)).toFixed(2)).toFixed(2)}
                              </p>
                            </div>
                          </div>
                        )
                      }
                      <div className="text-center mb-3 mt-5">
                        {listquantTotal < 1 ? (
                          ''
                        ) : (
                          <div className="text-center mb-3 mt-5">
                            {quantTotal === 0 || quantTotal === '0' ? (
                              <button
                                className="btn btn-primary btn-block"
                                disabled
                              >
                                Checkout
                              </button>
                            ) : (
                              <React.Fragment>
                                <Link
                                  to={{
                                    pathname: `/checkout/${this.props.match.params.id}`,
                                    state: {
                                      successPageMessage:
                                        this.state.successPageMessage,
                                      eventName: this.state.eventName,
                                      eventImage: this.state.eventImage,
                                      eventPlatform: this.state.eventPlatform,
                                      loaction: this.state.loaction,
                                      address2: this.state.address2,
                                      city: this.state.city,
                                      state: this.state.state,
                                      zip: this.state.zip,
                                      timeZone: this.state.timeZone,
                                      eventDate: this.state.eventDate,
                                      timeZone: this.state.timeZone,
                                      eventDays: this.state.eventDays,
                                      endTimeStamp: this.state.endTimeStamp,
                                      startTimeStamp: this.state.startTimeStamp,
                                      hour: this.state.hour,
                                      minute: this.state.minute,
                                      meridian: this.state.meridian,
                                      hourEnd: this.state.hourEnd,
                                      minuteEnd: this.state.minuteEnd,
                                      meridianEnd: this.state.meridianEnd,
                                      eventPayout: this.state.eventPayout,
                                      selectObj: SummaryArray,
                                      subtotal: Summarytotal,
                                      separateTicketDeliveryMode: this.state.separateTicketDeliveryMode
                                    },
                                  }}
                                  className="btn btn-primary btn-block"
                                >
                                  Checkout
                                </Link>
                              </React.Fragment>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mb-cart-info border-top d-flex d-lg-none d-xl-none">
            <div className="cart border-right h-100 d-flex align-items-center">
              <span className="count badge badge-count badge-brand font-size-14">
                {SummaryArrayLenght ? SummaryArrayLenght.length : totalLength}
              </span>
              <div className="dropdown dropup">
                <span
                  onClick={this.handleClickPopupVisible}
                  className="cart-toggle dropdown-toggle text-dark text-decoration-none"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fas fa-shopping-cart font-size-20"></i>
                  <i className="fas fa-chevron-up text-brand ml-3 font-size-12"></i>
                </span>

                {this.state.popupVisible && (
                  <div className="dropdown-menu cart-container show ">
                    <div className="p-4">
                      <h5 className="font-weight-bold pb-3">Order Summary</h5>

                      {SummaryArray.map((item, i) => {
                        return (
                          <React.Fragment>
                            {item.ticketQuantity === 0 ? (
                              ''
                            ) : (
                              <div className="row no-gutters border-bottom">
                                <div className="col-8">
                                  <p>
                                    {item.ticketQuantity
                                      ? item.ticketQuantity
                                      : 0}{' '}
                                    x {item.ticketName ? item.ticketName : ''}
                                  </p>
                                </div>
                                <div className="col-4">
                                  <p className="float-right">
                                    $
                                    {item.ticketPriceShow
                                      ? Number(item.ticketPriceShow).toFixed(2)
                                      : Number(0).toFixed(2)}
                                  </p>
                                </div>
                              </div>
                            )}
                          </React.Fragment>
                        );
                      })}

                      <div className="row no-gutters border-bottom pt-4">
                        <div className="col-8">
                          <p>Subtotal</p>
                        </div>
                        <div className="col-4">
                          <p className="float-right">
                            $
                            {Summarytotal
                              ? Number(Summarytotal).toFixed(2)
                              : Number(0).toFixed(2)}
                          </p>
                        </div>
                        <div className="col-8">
                          <p>Fees</p>
                        </div>
                        <div className="col-4">
                          <p className="float-right">
                            ${Number(totalFees).toFixed(2)}
                          </p>
                        </div>
                      </div>
                      <div className="row no-gutters pt-4">
                        <div className="col-8">
                          <p className="font-weight-bold">Total</p>
                        </div>
                        <div className="col-4">
                          <p className="float-right font-weight-bold">
                            $
                            {(Number(Summarytotal) + Number(totalFees)).toFixed(
                              2
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className="checkout d-flex align-items-center h-100">
              <p className="font-weight-bold m-0 mr-3">
                $
                {Summarytotal
                  ? (Number(Summarytotal) + Number(totalFees)).toFixed(2)
                  : Number(0).toFixed(2)}
              </p>

              {listquantTotal < 1 ? (
                ''
              ) : (
                <React.Fragment>
                  {quantTotal === 0 || quantTotal === '0' ? (
                    <button
                      className="btn btn-brand font-size-14 pl-4 pr-4 pt-2 pb-2"
                      disabled
                    >
                      Checkout
                    </button>
                  ) : (
                    <React.Fragment>
                      <Link
                        to={{
                          pathname: `/checkout/${this.props.match.params.id}`,
                          state: {
                            successPageMessage: this.state.successPageMessage,
                            eventName: this.state.eventName,
                            eventImage: this.state.eventImage,
                            eventPlatform: this.state.eventPlatform,
                            loaction: this.state.loaction,
                            address2: this.state.address2,
                            city: this.state.city,
                            state: this.state.state,
                            zip: this.state.zip,
                            timeZone: this.state.timeZone,
                            eventDate: this.state.eventDate,
                            eventDays: this.state.eventDays,
                            endTimeStamp: this.state.endTimeStamp,
                            startTimeStamp: this.state.startTimeStamp,
                            hour: this.state.hour,
                            minute: this.state.minute,
                            meridian: this.state.meridian,
                            hourEnd: this.state.hourEnd,
                            minuteEnd: this.state.minuteEnd,
                            meridianEnd: this.state.meridianEnd,
                            eventPayout: this.state.eventPayout,
                            selectObj: SummaryArray,
                            subtotal: Summarytotal,
                            separateTicketDeliveryMode: this.state.separateTicketDeliveryMode,
                          },
                        }}
                        className="btn btn-brand font-size-14 pl-4 pr-4 pt-2 pb-2"
                      >
                        Checkout
                      </Link>
                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
        <EventFooter />
      </div>
    );
  }
}

export default EventCart;
